import { SortingDirection } from '@doxyme/ui';
import { ADD_LOCATION, DELETE_LOCATION, EDIT_LOCATION, FETCH_LOCATIONS, UPDATE_LOCATION_FOR_MANAGE_USERS, UPDATE_LOCATION_FOR_SHARED_ROOM, } from '../constants/action-types';
import actions from '../actions';
import { create, edit, get, remove, updateLocationForManageUsers, updateLocationForSharedRoom, } from '../helpers';
import { selectInstitution } from '../../../../../../store/features/system';
import { addToast } from '../../../../../core/actions';
import { localeService, ToastType } from '../../../../../core';
import { sortingData } from '../selectors';
export const locationsLoader = (store) => (next) => (action) => {
    switch (action.type) {
        case FETCH_LOCATIONS: {
            const state = store.getState();
            const { id: institutionId } = selectInstitution(state);
            const { direction, field } = sortingData(state);
            store.dispatch(actions.loadingLocations());
            get({
                institutionId,
                isDesc: direction === SortingDirection.DESC,
                sortBy: field,
            })
                .then((locations) => {
                store.dispatch(actions.setLocations({ locations }));
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((err) => {
                console.error(err);
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        case ADD_LOCATION: {
            const state = store.getState();
            const { id: institutionId } = selectInstitution(state);
            const { name, onSubmit } = action.payload;
            create({ institutionId, name })
                .then(({ id }) => {
                const createMessage = localeService.formatMessageById('account.settings.locations.table.create-location-message');
                onSubmit?.(id);
                store.dispatch(addToast(ToastType.success, createMessage, 3000));
                store.dispatch(actions.fetchLocations());
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((error) => {
                console.error(error);
                store.dispatch(addToast(ToastType.error, error.message, 3000));
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        case EDIT_LOCATION: {
            const { name, locationId } = action.payload;
            edit({ locationId, name })
                .then(() => {
                const createMessage = localeService.formatMessageById('account.settings.locations.table.edit-location-message');
                store.dispatch(addToast(ToastType.success, createMessage, 3000));
                store.dispatch(actions.fetchLocations());
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((error) => {
                console.error(error);
                store.dispatch(addToast(ToastType.error, error.message, 3000));
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        case DELETE_LOCATION: {
            const { locationId } = action.payload;
            remove(locationId)
                .then((_) => {
                const msg = localeService.formatMessageById('account.settings.locations.table.delete-location-message');
                store.dispatch(addToast(ToastType.success, msg, 3000));
                store.dispatch(actions.fetchLocations());
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((error) => {
                console.error(error);
                store.dispatch(addToast(ToastType.error, error.message, 3000));
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        case UPDATE_LOCATION_FOR_SHARED_ROOM: {
            const { roomId, locationId } = action.payload;
            updateLocationForSharedRoom({
                id: roomId,
                props: {
                    locationId,
                },
            })
                .then(() => {
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((error) => {
                console.error(error);
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        case UPDATE_LOCATION_FOR_MANAGE_USERS: {
            const { institutionMemberId, locationId } = action.payload;
            const state = store.getState();
            const { id: institutionId } = selectInstitution(state);
            updateLocationForManageUsers({
                institutionMemberId,
                institutionId,
                props: {
                    locationId,
                },
            })
                .then(() => {
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
                return null;
            })
                .catch((error) => {
                console.error(error);
                // eslint-disable-next-line promise/no-callback-in-promise
                next(action);
            });
            break;
        }
        default: {
            next(action);
        }
    }
};
